import { Controller } from "@hotwired/stimulus";

export class TogglePasswordController extends Controller {
  static targets = ["input", "button", "iconHide", "iconShow"];

  toggle() {
    const input = this.inputTarget;
    const button = this.buttonTarget;

    const isHidden = input.type === "password";
    input.type = isHidden ? "text" : "password";

    if (this.hasIconHideTarget && this.hasIconShowTarget) {
      this.iconHideTarget.style.display = isHidden ? "none" : "";
      this.iconShowTarget.style.display = isHidden ? "" : "none";
    }

    button.setAttribute("aria-label", isHidden ? "パスワードを非表示" : "パスワードを表示");
  }
}

